import { Component, EventEmitter, Input, Output } from "@angular/core";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PatrimonioLiquido } from "src/app/model/patrimonio-liquido.model";


@Component({
    selector: 'app-patrimonio-liquido-listagem',
    templateUrl: './patrimonio-liquido-listagem.component.html',
    styleUrls: ['./patrimonio-liquido-listagem.component.scss'],
    standalone: false
})
export class PatrimonioLiquidoListagemComponent {

  @Input() patrimoniosLiquidos: PatrimonioLiquido[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrar: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarPLs: EventEmitter<any> = new EventEmitter<any>();

  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public rowHovered: number | null = null;

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.patrimoniosLiquidos = this.patrimoniosLiquidos.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarListaPatrimonioLiquido() {
    this.exportarPLs.emit(null);
  }

  hover(index: number) {
    this.rowHovered = index;
  }

  hoverClean() {
    this.rowHovered = null;
  }

}
